import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
if (process.env.NODE_ENV === "development" && window.Promise) {
    require("react-axe")(React, ReactDOM, 1000); // eslint-disable-line @typescript-eslint/no-var-requires
}
ReactDOM.render(React.createElement(App, null), document.getElementById("app"));
